export default function toSentence(array, oxford_comma = true) {
  if (!array || array.length === 0) {
    return "";
  }
  if (array.length > 1) {
    var lastWord = " and " + array.pop();
    if (oxford_comma && array.length > 1) {
      lastWord = "," + lastWord;
    }
  } else {
    var lastWord = "";
  }
  return array.join(", ") + lastWord;
}
